/* OMRI — Yotpo Reviews V3.20
   Comportements ciblés du widget Reviews :
   - conserve la pagination native Yotpo ;
   - replace le root du widget après changement de page ;
   - ne touche plus aux médias : leur géométrie 112×112 et la frame vidéo statique
     sont désormais garanties en CSS, ce qui reste stable après tous les rerenders Yotpo ;
   - aucun observer d'attributs ;
   - aucun remplacement du HTML Yotpo.
*/
(() => {
  'use strict';

  const ROOT_SELECTOR = '#yotpo-reviews-main-widget';
  const PAGINATION_SELECTOR = '.yotpo-horizontal-pagination-container';
  const BUTTON_SELECTOR = '.yotpo-reviews-pagination-item';
  const LIST_SELECTOR = '.yotpo-reviews-list-wrapper';

  const isDisabled = button =>
    button.disabled ||
    button.classList.contains('disabled') ||
    button.getAttribute('aria-disabled') === 'true';

  const isCurrentPage = button =>
    button.classList.contains('selected') ||
    button.getAttribute('aria-current') === 'true' ||
    button.closest('.yotpo-pagination-number')?.classList.contains('selected');

  function stickyHeaderOffset() {
    const selectors = [
      '#shopify-section-header',
      '.shopify-section-group-header-group',
      'sticky-header',
      'header[role="banner"]'
    ];

    let bottom = 0;

    [...new Set(selectors.flatMap(selector => [...document.querySelectorAll(selector)]))]
      .forEach(element => {
        const style = getComputedStyle(element);
        const stickyLike =
          style.position === 'fixed' ||
          style.position === 'sticky' ||
          element.matches('sticky-header');

        if (!stickyLike || style.display === 'none' || style.visibility === 'hidden') return;

        const rect = element.getBoundingClientRect();
        if (rect.height <= 0 || rect.bottom <= 0 || rect.top > 2) return;

        bottom = Math.max(bottom, rect.bottom);
      });

    return Math.max(0, Math.round(bottom));
  }

  function scrollReviewsRoot(root) {
    if (!root?.isConnected) return;

    const target =
      window.scrollY +
      root.getBoundingClientRect().top -
      stickyHeaderOffset();

    window.scrollTo({
      top: Math.max(0, target),
      behavior: 'smooth'
    });
  }

  function afterPaginationRender(root) {
    const list = root.querySelector(LIST_SELECTOR);
    let finished = false;
    let timer = 0;
    let observer = null;

    const finish = () => {
      if (finished) return;
      finished = true;

      observer?.disconnect();
      window.clearTimeout(timer);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => scrollReviewsRoot(root));
      });
    };

    if (list) {
      observer = new MutationObserver(finish);
      observer.observe(list, {
        childList: true,
        subtree: true
      });
    }

    timer = window.setTimeout(finish, 700);
  }

  document.addEventListener('click', event => {
    const button = event.target.closest(
      `${ROOT_SELECTOR} ${PAGINATION_SELECTOR} ${BUTTON_SELECTOR}`
    );

    if (!button || isDisabled(button) || isCurrentPage(button)) return;

    const root = button.closest(ROOT_SELECTOR);
    if (!root) return;

    afterPaginationRender(root);
  }, true);
})();
